import { ICurrency } from 'store/fetchers/currencies'

export function getHashExplorerLink(currency: ICurrency, hash: string) {
  if (!currency?.template_explorer_hash) {
    return null
  }
  return currency.template_explorer_hash?.replace(':hash', hash) || null
}
